import { useCallback, useEffect, useLayoutEffect, useRef } from "react";

const useUniEffect = typeof window === "undefined" ? useEffect : useLayoutEffect;

function useUnmounted() {
	const unmountedRef = useRef(false);

	useUniEffect(() => {
		unmountedRef.current = false;
		return () => {
			unmountedRef.current = true;
		};
	}, []);

	return unmountedRef;
}

export function useIfMounted(fn, isUnmountedRef) {
	return useCallback(
		(...args) => {
			if (isUnmountedRef.current) return undefined;
			return fn(...args);
		},
		[fn, isUnmountedRef],
	);
}

export default useUnmounted;
